import { axios } from '@complispace/cs-design-system';

const baseURL = process.env.CONTENT_ENGINE_URL;
const featuresBaseUrl = `${baseURL}/app/features`;

const features = {
  // GET /app/features
  async getFeatures(featureNames) {
    if (featureNames && featureNames.length) {
      return axios.get(featuresBaseUrl, {
        params: {
          features: featureNames
        }
      });
    }

    return {};
  }
};

export default features;
